import React from "react";
import { Container, Row, Col } from "reactstrap";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

const Footer = (props) => {
  const { t } = props;
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
              <Col lg={12}>
                <div className="text-sm-end d-none d-sm-block">
                  {t('shared.copyright', 'Copyright ©')} {new Date().getFullYear()} {t('shared.arcmedix_all_rights_reserved', 'Arcmedix. All rights reserved')}
                </div>
              </Col>
            </Row>
        </Container>
      </footer>
    </React.Fragment>

  );
};

Footer.propTypes = {
  t: PropTypes.func,
};

export default withTranslation()(Footer);